import { render, staticRenderFns } from "./CRMLawcaseLog.vue?vue&type=template&id=53826b15&scoped=true&"
import script from "./CRMLawcaseLog.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseLog.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseLog.vue?vue&type=style&index=0&id=53826b15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53826b15",
  null
  
)

export default component.exports